module.exports = __webpack_public_path__ + "img/logo-bayton-mktg-white.cf3291f9.svg";